var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-item",
      class: { "list-item--fixed-label-width": _vm.labelWidthInPx },
      style: "--label-width: " + _vm.labelWidthInPx + "px"
    },
    [
      _c("div", { staticClass: "list-item__label" }, [
        _c(
          "h6",
          { staticClass: "mb-0" },
          [
            _vm.icon
              ? _c("font-awesome-icon", {
                  staticClass: "text-primary mr-2",
                  attrs: { icon: ["fad", _vm.icon], "fixed-width": "" }
                })
              : _vm._e(),
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "list-item__content",
          class: _vm.textClass || "text-secondary"
        },
        [_vm._v("\n    " + _vm._s(_vm.text || "/") + "\n  ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }